export default __webpack_public_path__ + "static/media/ebook.36075d21.svg";